import { atom, getDefaultStore } from 'jotai';

import { User } from '../types/user';

export const opalUserAtom = atom<User>({} as User);

export const getUser = () => {
  const store = getDefaultStore();
  const user = store.get(opalUserAtom);
  if (!user) {
    throw new Error('User not found');
  }
  return user;
};
